import { Component, Input, OnInit, signal } from '@angular/core';
import { Trade } from '../trades.model';
import { LotsService } from 'src/app/services/lots.service';
import { Store } from '@ngrx/store';
import { UserState } from 'src/app/store/user/user.reducer';
import { distinctUntilChanged, map } from 'rxjs';
import { UserDetails } from '../../login/user.model';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipSet, MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { PriceTypePipe } from 'src/app/pipes/price-type.pipe';
import { selectUser } from 'src/app/store/user/user.selectors';

@Component({
  selector: 'app-trades-item',
  templateUrl: './trades-item.component.html',
  styleUrls: ['./trades-item.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    PriceTypePipe,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
  ],
})
export class TradesItemComponent implements OnInit {
  @Input() item: Trade;
  userDetails = signal<UserDetails>(null);

  constructor(
    readonly lotsService: LotsService,
    private store: Store<{ user: UserState }>
  ) {}

  ngOnInit(): void {
    // get user data
    this.store
      .select(selectUser)
      .pipe(
        distinctUntilChanged(),
        map((user) => {
          this.userDetails.set({ ...user });
        })
      )
      .subscribe();
  }

  deliveryTypeDisplay: { [key: string]: string } = {
    Delivered: 'Dlvd.',
    'FOB Facility': 'FOB Fac.',
    'FOB Farm': 'FOB Frm.',
    // Add more mappings as needed
  };

  getDisplayValue(deliveryType: string): string {
    return this.deliveryTypeDisplay[deliveryType] || deliveryType;
  }

  isSameYear(): boolean {
    return (
      new Date(this.item.ship_begin).getFullYear() ===
      new Date(this.item.ship_end).getFullYear()
    );
  }

  // formatProductType(): string {
  //   return this.item.product_type.replace(this.item.grade, '').trim();
  // }
}
